// src/store/promptSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { handleParagraphPrompt, handlePrompt } from "../api/promptAPI";

// 10 statements (for Read + Listen)
export const promptResponse = createAsyncThunk(
  "prompt/fetchResponse",
  async () => {
    const response = await handlePrompt(); // { reply: [...] }
    return response;
  }
);

// paragraph + questions (for ParagraphAssessment)
export const paragraphResponse = createAsyncThunk(
  "prompt/fetchParagraph",
  async () => {
    const response = await handleParagraphPrompt(); // { paragraph, questions }
    return response;
  }
);

const promptSlice = createSlice({
  name: "prompt",
  initialState: {
    // Keep old key for Read/Listen so nothing else breaks
    response: null, // expects { reply: [...] }
    // New key for ParagraphAssessment
    paragraphData: null, // expects { paragraph: string, questions: string[] }
    loading: false,
    error: null,
  },
  reducers: {
    setResponse: (state, action) => {
      state.response = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // ---- Read/Listen ----
      .addCase(promptResponse.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(promptResponse.fulfilled, (state, action) => {
        state.loading = false;
        state.response = action.payload; // { reply: [...] }
      })
      .addCase(promptResponse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to fetch statements";
      })

      // ---- Paragraph ----
      .addCase(paragraphResponse.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(paragraphResponse.fulfilled, (state, action) => {
        state.loading = false;
        state.paragraphData = action.payload; // { paragraph, questions }
      })
      .addCase(paragraphResponse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to fetch paragraph";
      });
  },
});

export default promptSlice.reducer;
